import React from 'react'
import Certificates from '../components/Certificates'

const CertificatesPage = () => {
  return (
    <div style={{padding:"5rem 0",backgroundColor:"var(--green)"}}>
      <h3 className='sec-title'>Certificates</h3>
    <Certificates/>
      
    </div>
  )
}

export default CertificatesPage
